export default "__VITE_ASSET__DfWLRdgl__"